if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      for (let item of MutationList) {
        if (item.target.className === "countPill cart-quantity") {
          BSS_B2B.observer?.cartSubject.notifyObserver(
            "CartMutate",
            "CartPriceMutate"
          );
          BSS_B2B.observer?.cartSubject.listenCartCheckout();
        }
        if (item.target.className === "product_template") {
          document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);

  function buttonCheckout() {
    const checkoutContainer = document.querySelector(
      ".cart-dropdown .btn.product-btn"
    );
    const checkoutButton = document.querySelector(
      ".cart-dropdown .bss-checkout"
    );
    if (checkoutContainer) {
      checkoutContainer.style.display = "none";
    }
    if (checkoutButton) {
      checkoutButton.style.display = "block";
    }
  }
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      buttonCheckout();
    }, 1200);
  });
}
